var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "factor-base-reveal" },
    [
      _c(
        "div",
        {
          staticClass: "card mdkp-card",
          staticStyle: { margin: "0 0 50px 0" },
        },
        [
          _c(
            "div",
            {
              staticClass: "card-body",
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                gap: "30px",
              },
            },
            [
              _c("workflow-header", {
                on: { "show-byor-tab": _vm.showByorTab },
              }),
              _c(
                "div",
                { staticClass: "reveal-query-section" },
                [
                  _c("workflow-ops-menu", {
                    attrs: {
                      "hypothesis-generation-mode":
                        _vm.hypothesisGenerationMode,
                      "can-export-workflow": _vm.canExportWorkflow,
                      busy: _vm.workflowExportImportBusy,
                      "query-builder-visible": _vm.queryHelperLinkVisible,
                    },
                    on: {
                      "set-mode": _vm.onOpsSetMode,
                      "reset-search": _vm.onOpsResetSearch,
                      "export-workflow": _vm.exportWorkflowSnapshot,
                      "import-workflow-file": _vm.onWorkflowImportFile,
                      "open-query-builder": _vm.openQueryHelperModal,
                      "open-query-guidelines": function ($event) {
                        _vm.queryGuidelinesOpen = true
                      },
                      "open-search-terms-extraction": function ($event) {
                        _vm.searchTermsExtractionOpen = true
                      },
                    },
                  }),
                  _c("workflow-query-bar", {
                    ref: "workflowQueryBar",
                    attrs: {
                      "user-query": _vm.userQuery,
                      "search-input-placeholder": _vm.searchInputPlaceholder,
                      "search-criteria-type": _vm.searchCriteriaType,
                    },
                    on: {
                      "update:userQuery": _vm.onUserQueryUpdate,
                      "update:searchCriteriaType":
                        _vm.onSearchCriteriaTypeUpdate,
                      "query-focus": _vm.onQueryInputFocus,
                      "query-blur": _vm.onQueryInputBlur,
                      reveal: _vm.queryParse,
                    },
                  }),
                ],
                1
              ),
              false
                ? [
                    _vm.searchCriteria && _vm.searchCriteria.length
                      ? _c("div", { staticClass: "mt-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "font-weight-bold mb-2",
                              staticStyle: {
                                color: "#FF6600",
                                "font-size": "1.1em",
                              },
                            },
                            [
                              _vm._v(
                                "Extracted research criteria from your Query"
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "section-header d-flex justify-content-between align-items-start mb-2",
                              on: {
                                click: function ($event) {
                                  _vm.display_search_criteria =
                                    !_vm.display_search_criteria
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex flex-column gap-2",
                                  staticStyle: {
                                    "max-width": "calc(100% - 100px)",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-wrap align-items-baseline gap-2",
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v("Phenotype Terms:"),
                                      ]),
                                      _vm._l(
                                        _vm.lastPhenotypeTerms,
                                        function (item) {
                                          return _c(
                                            "span",
                                            { key: item, staticClass: "pill" },
                                            [_vm._v(_vm._s(item))]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-wrap align-items-baseline gap-2",
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v("Mechanism Terms:"),
                                      ]),
                                      _vm._l(
                                        _vm.lastMechanismTerms,
                                        function (item) {
                                          return _c(
                                            "span",
                                            { key: item, staticClass: "pill" },
                                            [_vm._v(_vm._s(item))]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-wrap align-items-baseline gap-2",
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v("Your Research Context:"),
                                      ]),
                                      _c("span", { staticClass: "pill" }, [
                                        _vm._v(
                                          _vm._s(_vm.searchCriteria[1].values)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _c("span", { staticClass: "small text-muted" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.display_search_criteria
                                      ? "show less"
                                      : "show more"
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "criteria-detail",
                              class: {
                                collapsed: !_vm.display_search_criteria,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-end mb-2",
                                },
                                [
                                  !_vm.edit_search_criteria
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-info btn-sm",
                                          on: {
                                            click: function ($event) {
                                              return _vm.editSearchCriteria()
                                            },
                                          },
                                        },
                                        [_vm._v("✎ Edit search criteria")]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "d-flex gap-1" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-warning btn-sm",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.cancelEditSearchCriteria()
                                                },
                                              },
                                            },
                                            [_vm._v("Cancel")]
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-success btn-sm",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.saveSearchCriteria()
                                                },
                                              },
                                            },
                                            [_vm._v("Save search criteria")]
                                          ),
                                        ]
                                      ),
                                ]
                              ),
                              _c(
                                "p",
                                { staticClass: "small font-weight-bold mb-2" },
                                [
                                  _vm._v(
                                    "The values below will be used to inform subsequent steps."
                                  ),
                                ]
                              ),
                              _c("b-table", {
                                attrs: {
                                  items: _vm.searchCriteria,
                                  fields: [
                                    {
                                      key: "search_criteria",
                                      label: "Search Criteria",
                                    },
                                    { key: "values", label: "Values" },
                                    { key: "why", label: "Why" },
                                    { key: "purpose", label: "Purpose" },
                                  ],
                                  small: "",
                                  striped: "",
                                  hover: "",
                                  responsive: "sm",
                                  "head-variant": "light",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "cell(values)",
                                      fn: function (row) {
                                        return [
                                          Array.isArray(row.item.values)
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "d-inline-flex flex-wrap gap-1",
                                                },
                                                [
                                                  _vm._l(
                                                    row.item.values,
                                                    function (item) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: item,
                                                          staticClass: "pill",
                                                          class: {
                                                            editable:
                                                              _vm.edit_search_criteria,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.edit_search_criteria &&
                                                                _vm.removeSearchTerm(
                                                                  item
                                                                )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(item))]
                                                      )
                                                    }
                                                  ),
                                                  _vm.edit_search_criteria
                                                    ? _c("input", {
                                                        staticClass: "pill new",
                                                        attrs: {
                                                          placeholder: "+",
                                                        },
                                                        on: {
                                                          keyup: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              !$event.type.indexOf(
                                                                "key"
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "enter",
                                                                13,
                                                                $event.key,
                                                                "Enter"
                                                              )
                                                            )
                                                              return null
                                                            return _vm.addSearchTerm(
                                                              $event
                                                            )
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.addSearchTerm(
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                2
                                              )
                                            : _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: row.item.values,
                                                    expression:
                                                      "row.item.values",
                                                  },
                                                ],
                                                staticClass:
                                                  "pill form-control",
                                                staticStyle: {
                                                  width: "100%",
                                                  "field-sizing": "content",
                                                  "min-height": "2.5em",
                                                },
                                                attrs: {
                                                  disabled:
                                                    !_vm.edit_search_criteria,
                                                },
                                                domProps: {
                                                  value: row.item.values,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      row.item,
                                                      "values",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                        ]
                                      },
                                    },
                                    {
                                      key: "cell(why)",
                                      fn: function (data) {
                                        return [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(data.value),
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1842046533
                                ),
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-end mt-2",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: {
                                        disabled: _vm.edit_search_criteria,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onResearch()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.searchMode === "step"
                                              ? "Continue"
                                              : "Re-search"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm.steps && _vm.steps.length
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                      },
                    },
                    [
                      _c("workflow-tab-bar", {
                        attrs: {
                          "active-tab": _vm.showTab,
                          "data-tab-enabled": _vm.revealDataTabEnabled,
                          "results-tab-enabled": _vm.revealResultsTabEnabled,
                          "workflow-error-steps": _vm.workflowErrorSteps,
                        },
                        on: { "select-tab": _vm.switchRevealTab },
                      }),
                      _c(
                        "div",
                        [
                          _vm.showTab === "terms"
                            ? _c("workflow-terms-panel", {
                                attrs: {
                                  "extraction-step": _vm.revealExtractionStep,
                                  "extraction-step-time-label":
                                    _vm.extractionStepTimeLabel,
                                  "loading-search-criteria":
                                    _vm.loading_search_criteria,
                                  "gate-active": _vm.stepApprovalGateActive,
                                  "gate-step-id": _vm.stepApprovalGateStepId,
                                  "search-criteria-edit-rows":
                                    _vm.searchCriteriaEditRows,
                                  "multi-query-route-edit-rows":
                                    _vm.multiQueryRouteEditRows,
                                  "extraction-gate-done":
                                    _vm.searchCriteriaExtractionGateDone,
                                  "extraction-ambiguity-check":
                                    _vm.extractionAmbiguityCheck,
                                  "extraction-ambiguity-dismissed":
                                    _vm.extractionAmbiguityDismissed,
                                  "use-per-route-search-terms-editor":
                                    _vm.usePerRouteSearchTermsEditor,
                                  "shared-research-context":
                                    _vm.sharedResearchContextTerm,
                                  "multi-query-routes": _vm.multiQueryRoutes,
                                  "selected-route-id": _vm.selectedRouteId,
                                  "alternative-queries":
                                    _vm.lastAlternativeQueries,
                                },
                                on: {
                                  "approve-gate": _vm.approveStepGate,
                                  "update:sharedResearchContext": function (
                                    $event
                                  ) {
                                    _vm.sharedResearchContextTerm = $event
                                  },
                                  "dismiss-ambiguity": function ($event) {
                                    _vm.extractionAmbiguityDismissed = true
                                  },
                                  "update-route-edit-field":
                                    _vm.onRouteEditFieldUpdate,
                                  "select-route": _vm.onSelectRetrievalRoute,
                                  "select-alternative-query":
                                    _vm.onAlternativeQuerySelected,
                                },
                              })
                            : _vm._e(),
                          _vm.showDataTabContent
                            ? _c(
                                "workflow-data-panel",
                                _vm._b(
                                  {
                                    ref: "workflowDataPanel",
                                    attrs: { helpers: _vm.dataPanelHelpers },
                                    on: {
                                      "approve-gate": _vm.approveStepGate,
                                      "download-raw-json":
                                        _vm.downloadLastHybridSearchRawJson,
                                      "pair-included-toggle":
                                        _vm.onPairIncludedToggle,
                                      "toggle-factor-row":
                                        _vm.toggleFactorGenesRow,
                                      "open-factor-connectivity":
                                        _vm.openFactorConnectivityPopup,
                                      "gene-set-row-toggle":
                                        _vm.onGeneSetRowToggled,
                                      "update:mainTableCurrentPage": function (
                                        $event
                                      ) {
                                        _vm.mainTableCurrentPage = $event
                                      },
                                      "update:subtable-page":
                                        _vm.onSubtablePageUpdate,
                                      "update:researchIntention":
                                        _vm.onGeneSetEntryResearchIntentionUpdate,
                                      "update:llmFeedScope":
                                        _vm.onLlmFeedScopeUpdate,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "data-viz",
                                          fn: function () {
                                            return [
                                              _vm.dataVizReady
                                                ? _c(
                                                    "factor-base-reveal-heatmap",
                                                    {
                                                      key:
                                                        "fbr-heatmap-" +
                                                        _vm.workflowVisualKey +
                                                        "-" +
                                                        _vm
                                                          .factorDataTableRowsFiltered
                                                          .length,
                                                      ref: "factorBaseRevealHeatmap",
                                                      attrs: {
                                                        "factor-data":
                                                          _vm.factorData,
                                                        "factor-data-table-rows":
                                                          _vm.factorDataTableRowsFiltered,
                                                        "phenotype-description-by-id":
                                                          _vm.phenotypeDescriptionById,
                                                        "row-label-mode":
                                                          _vm.isGeneSetEntryMode
                                                            ? "factor"
                                                            : "phenotype",
                                                        "emphasize-search-context-genes":
                                                          _vm.emphasizeSearchContextGenes,
                                                        "cell-color-mode":
                                                          _vm.isGeneSetEntryMode
                                                            ? "factorValue"
                                                            : "association",
                                                        "show-association-score-header":
                                                          !_vm.isGeneSetEntryMode,
                                                        "show-association-legend":
                                                          !_vm.isGeneSetEntryMode,
                                                        "phenotype-association-filters":
                                                          _vm.phenotypeAssociationFilters,
                                                        "heatmap-view-filters":
                                                          _vm.heatmapViewFilters,
                                                        "selected-nodes":
                                                          _vm.heatmapSelectedNodes,
                                                        "show-workflow-selection-chrome":
                                                          "",
                                                        "show-group-by-controls": false,
                                                        "show-direction-in-row-labels": false,
                                                        "saved-explanations":
                                                          _vm.savedSelectedNodesExplainMenuItems,
                                                        "saved-dataset-runs":
                                                          _vm.savedSelectedNodesProvenanceMenuItems,
                                                        height: "auto",
                                                      },
                                                      on: {
                                                        "update:phenotypeAssociationFilters":
                                                          function ($event) {
                                                            _vm.phenotypeAssociationFilters =
                                                              $event
                                                          },
                                                        "update:phenotype-association-filters":
                                                          function ($event) {
                                                            _vm.phenotypeAssociationFilters =
                                                              $event
                                                          },
                                                        "update:heatmapViewFilters":
                                                          function ($event) {
                                                            _vm.heatmapViewFilters =
                                                              $event
                                                          },
                                                        "update:heatmap-view-filters":
                                                          function ($event) {
                                                            _vm.heatmapViewFilters =
                                                              $event
                                                          },
                                                        "update:selectedNodes":
                                                          function ($event) {
                                                            _vm.heatmapSelectedNodes =
                                                              $event
                                                          },
                                                        "update:selected-nodes":
                                                          function ($event) {
                                                            _vm.heatmapSelectedNodes =
                                                              $event
                                                          },
                                                        "analyze-explain":
                                                          _vm.onAnalyzeSelectedNodesExplain,
                                                        "analyze-provenance":
                                                          _vm.onAnalyzeSelectedNodesProvenance,
                                                        "open-saved-explanation":
                                                          _vm.onOpenSavedSelectedNodesExplanation,
                                                        "open-saved-dataset":
                                                          _vm.onOpenSavedSelectedNodesProvenance,
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      1938729370
                                    ),
                                  },
                                  "workflow-data-panel",
                                  _vm.dataPanelProps,
                                  false
                                )
                              )
                            : _vm._e(),
                          _vm.showResultsTabContent
                            ? _c(
                                "workflow-results-panel",
                                _vm._b(
                                  {
                                    ref: "workflowResultsPanel",
                                    attrs: { helpers: _vm.resultsPanelHelpers },
                                    on: {
                                      "retry-hypotheses":
                                        _vm.retryMechanismHypotheses,
                                      "retry-hypotheses-relaxed":
                                        _vm.retryMechanismHypothesesRelaxed,
                                      "download-report": _vm.downloadReport,
                                      "apply-suggested-query":
                                        _vm.applySuggestedOptimizedQuery,
                                      "update:displayMechanisms": function (
                                        $event
                                      ) {
                                        _vm.display_mechanisms = $event
                                      },
                                      "set-mechanism-map-view":
                                        _vm.setMechanismMapViewMode,
                                      "open-network-popup":
                                        _vm.openNetworkPopup,
                                      "open-design-protocol":
                                        _vm.openDesignProtocolForMechanism,
                                      "select-alternative-query":
                                        _vm.onAlternativeQuerySelected,
                                      "copy-mechanism-for-llm":
                                        _vm.copyMechanismForLlm,
                                      "download-mechanism-handoff":
                                        _vm.downloadMechanismHandoffPackage,
                                      "toggle-factor-row":
                                        _vm.toggleFactorGenesRow,
                                      "generate-remaining-pair":
                                        _vm.generateHypothesisForRemainingPair,
                                      "open-factor-connectivity":
                                        _vm.openFactorConnectivityPopup,
                                      "gene-set-row-toggle":
                                        _vm.onGeneSetRowToggled,
                                      "update:remainingTableCurrentPage":
                                        function ($event) {
                                          _vm.remainingTableCurrentPage = $event
                                        },
                                      "update:subtable-page":
                                        _vm.onSubtablePageUpdate,
                                    },
                                  },
                                  "workflow-results-panel",
                                  _vm.resultsPanelProps,
                                  false
                                )
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-modal",
                {
                  attrs: {
                    id: "gene-set-entry-progress-modal",
                    centered: "",
                    "hide-header-close": "",
                    "no-close-on-backdrop": "",
                    "no-close-on-esc": "",
                    "hide-footer": _vm.geneSetEntry.status === "loading",
                    title: _vm.geneSetEntry.offerMainPathFallback
                      ? "Gene-set entry retrieval failed"
                      : "Gene-set entry data loading",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _vm.geneSetEntry.offerMainPathFallback
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "outline-secondary",
                                    size: "sm",
                                  },
                                  on: {
                                    click: _vm.dismissGeneSetEntryProgressModal,
                                  },
                                },
                                [_vm._v(" Dismiss ")]
                              )
                            : _vm._e(),
                          _vm.geneSetEntry.offerMainPathFallback
                            ? _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary", size: "sm" },
                                  on: {
                                    click: _vm.onSwitchGeneSetEntryToMainPath,
                                  },
                                },
                                [_vm._v(" Switch to text-query search ")]
                              )
                            : _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary", size: "sm" },
                                  on: {
                                    click: _vm.dismissGeneSetEntryProgressModal,
                                  },
                                },
                                [_vm._v(" OK ")]
                              ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.geneSetEntryProgressModalOpen,
                    callback: function ($$v) {
                      _vm.geneSetEntryProgressModalOpen = $$v
                    },
                    expression: "geneSetEntryProgressModalOpen",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-start" },
                    [
                      _vm.geneSetEntry.status === "loading"
                        ? _c("b-spinner", { staticClass: "mr-3 mt-1" })
                        : _vm._e(),
                      _c("div", { staticStyle: { "min-width": "0" } }, [
                        _c("div", { staticClass: "font-weight-bold mb-1" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.geneSetEntry.progress &&
                                  _vm.geneSetEntry.progress.message) ||
                                  "Working…"
                              ) +
                              " "
                          ),
                        ]),
                        _vm.geneSetEntry.progress &&
                        _vm.geneSetEntry.progress.detail
                          ? _c(
                              "div",
                              {
                                staticClass: "small text-muted",
                                staticStyle: {
                                  "white-space": "pre-line",
                                  "line-height": "1.45",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.geneSetEntry.progress.detail) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.geneSetEntry.inputGenes &&
                        _vm.geneSetEntry.inputGenes.length
                          ? _c(
                              "div",
                              { staticClass: "small text-muted mt-2" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.geneSetEntry.inputGenes.length) +
                                    " gene(s) "
                                ),
                                _vm.geneSetEntry.inputGenes.length <= 12
                                  ? _c("span", [
                                      _vm._v(
                                        " : " +
                                          _vm._s(
                                            _vm.geneSetEntry.inputGenes.join(
                                              ", "
                                            )
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        " : " +
                                          _vm._s(
                                            _vm.geneSetEntry.inputGenes
                                              .slice(0, 8)
                                              .join(", ")
                                          ) +
                                          "… "
                                      ),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                        _vm.geneSetEntry.offerMainPathFallback
                          ? _c(
                              "div",
                              {
                                staticClass: "mt-3 p-2 border rounded",
                                staticStyle: {
                                  background: "#f8f9fa",
                                  "font-size": "0.9rem",
                                  "line-height": "1.45",
                                },
                              },
                              [
                                _vm._v(
                                  " Switch to the standard text-query path? Your genes will be placed in a default research question, the URL will use "
                                ),
                                _c("code", [_vm._v("query=")]),
                                _vm._v(" instead of "),
                                _c("code", [_vm._v("genes=")]),
                                _vm._v(
                                  ", and search-term extraction will start. "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ],
            2
          ),
        ]
      ),
      _c(
        "workflow-query-helper-modal",
        _vm._g(
          _vm._b(
            { attrs: { helpers: _vm.queryHelperModalHelpers } },
            "workflow-query-helper-modal",
            _vm.queryHelperModalProps,
            false
          ),
          _vm.queryHelperModalListeners
        )
      ),
      _c("workflow-query-guidelines-modal", {
        attrs: { open: _vm.queryGuidelinesOpen },
        on: {
          "update:open": function ($event) {
            _vm.queryGuidelinesOpen = $event
          },
        },
      }),
      _c("workflow-search-terms-extraction-modal", {
        attrs: { open: _vm.searchTermsExtractionOpen },
        on: {
          "update:open": function ($event) {
            _vm.searchTermsExtractionOpen = $event
          },
        },
      }),
      _c(
        "workflow-network-modals",
        _vm._g(
          _vm._b(
            { attrs: { helpers: _vm.networkModalsHelpers } },
            "workflow-network-modals",
            _vm.networkModalsProps,
            false
          ),
          _vm.networkModalsListeners
        )
      ),
      _c("workspace-explain-graph-modal", {
        attrs: {
          open: _vm.selectedNodesExplainOpen,
          entry: _vm.selectedNodesExplainEntry,
          scope: _vm.selectedNodesExplainScope,
          "helper-text": _vm.selectedNodesExplainHelperText,
          loading: _vm.selectedNodesExplainLoading,
          "llm-available": true,
          "key-node-count": _vm.heatmapSelectedNodes.length,
          "node-count": _vm.selectedNodesExplainNodeCount,
          "edge-count": _vm.selectedNodesExplainEdgeCount,
          "scope-locked": true,
        },
        on: {
          close: _vm.closeSelectedNodesExplain,
          run: _vm.runSelectedNodesExplanationModal,
          "update-entry": _vm.onSelectedNodesExplainEntryPatch,
          "update:scope": function ($event) {
            _vm.selectedNodesExplainScope = $event
          },
        },
      }),
      _c("workflow-selected-nodes-provenance-modal", {
        attrs: {
          open: _vm.selectedNodesProvenanceOpen,
          "gene-set-ids": _vm.selectedNodesProvenanceGeneSetIds,
          items: _vm.selectedNodesProvenanceItems,
        },
        on: {
          close: function ($event) {
            _vm.selectedNodesProvenanceOpen = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }